module.exports = __webpack_public_path__ + "static/img/DVB-DrSUgOfH.0209e65.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img2/DVB-DrSUgOfH.png
// module id = 01Ur
// module chunks = 16